import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { api } from '../services/api';

export const fetchChampionshipStats = createAsyncThunk('stats/fetchChampionshipStats', async () => {
  try {
    const response = await api.get('/championship-stats');
    return response.data;
  } catch (error) {
    return [];
  }
});

const statsSlice = createSlice({
  name: 'stats',
  initialState: {
    data: null,
    status: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchChampionshipStats.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchChampionshipStats.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload;
      })
      .addCase(fetchChampionshipStats.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export const selectStatsData = (state) => state.stats.data;
export const selectStatsStatus = (state) => state.stats.status;

export default statsSlice.reducer;
